import { render } from "./AddUpiAccount.vue?vue&type=template&id=94245440"
import script from "./AddUpiAccount.vue?vue&type=script&lang=js"
export * from "./AddUpiAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__